import React, { useState, useRef, useEffect } from "react";

import {
    Box,
    Paper,
    Divider,
    TextField,
    Grid,
    Typography,
    Button,
    IconButton,
    InputAdornment,
    Stack,
    Card,
    styled,
    FormControl,
    MenuItem,
    FormHelperText,
    Select,
    InputLabel
} from '@mui/material';

// import dayjs from "dayjs";

import QRCode from "qrcode.react";

import { useFormik } from 'formik';

import { useNavigate } from "react-router-dom";

import { Page, Text, View, Document, StyleSheet, Image, PDFViewer } from '@react-pdf/renderer';

import CommonSectionHeader from "../../common/CommonSectionHeader"
import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonRestricted from "../../common/CommonRestricted";
import DatePickerComponent from "../../common/DatePickerComponent";
import { CommonIcons, icons } from "../../common/CommonIcons"

import LocationSelector from "../../selector/LocationSelector";

import { useRepositories, repositoryTypes, targetTypes } from "../../../hooks/api/useRepositories"
import { useItems, itemTypes } from "../../../hooks/api/useItems";

import { useAppContextFeatures } from "../../../context/AppContext";

import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from "../../../hooks/usePermissions";

import { validationSchema, initialValues } from "../../../schema/repositories/packageSchema"
import { packingMethods } from "../../../schema/repositories/packagePackSchema"
import { getUId } from "../../../utils/formatId"

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export default function NewPackage({
    routeType
}) {

    const { promptMessage } = useSystemPrompt();
    const { isLoading, create } = useRepositories({ repositoryType: repositoryTypes.package, targetType: targetTypes.package })
    const { list: listUoms } = useItems({ itemType: itemTypes.uom })
    const { setSystemLoading, getLocationIds, setLocationIds } = useAppContextFeatures();

    const navigate = useNavigate();
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.repository.id, scopeTypes.repository.package.id)

    const [dataPackages, setDataPackages] = useState([])

    const { openCustomDrawer, closeCustomDrawer } = useAppContextFeatures()

    const [dataUoms, setDataUoms] = useState([])

    const onSubmit = async (currentValues) => {

        setSystemLoading(true)

        try {

            const qty = parseInt(currentValues?.qty.value, 10)

            let myArray = [];

            for (let i = 0; i < qty; i += 1) {
                myArray.push(i)
            }

            let totalResponses = [];

            await Promise.all(

                // Use map to create an array of promises,  
                // with one promise for each item in myArray. 
                myArray.map(async item => {

                    // generate unique no for package
                    let uniqueNo = 12345; // getUId({ version: 1 })

                    // uniqueNo = uniqueNo.slice(0, 20).toUpperCase()

                    let data = getPostData({ uniqueNo, currentValues })

                    // Wait for the promise returned by  
                    // doSomethingAsync to resolve. 
                    // await doSomethingAsync(item); 

                    const response = await create({ data });

                    // console.log('response', response)

                    if (response?.data?.repository) {
                        totalResponses.push(
                            response.data.repository
                        )
                    }

                })
            );

            setDataPackages(totalResponses)

            promptMessage(true, `${qty} packages created successfully. You may download labels for print`)

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

        setSystemLoading(false)

    }

    const fetchUoms = async (keyword) => {

        setSystemLoading(true)

        try {

            const props = {
                limit: -1,
                skip: 0,
                sortInfo: {
                    id: "id",
                    dir: 0,
                },
                filterValue: [
                    // {
                    //     name: "number_alternative",
                    //     operator: filterOperatorTypes.eq,
                    //     value: keyword
                    // }
                ]
            }

            const { data } = await listUoms(props)

            // console.log('data', data)

            setDataUoms(data?.item_uoms ? data.item_uoms : [])


        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

        return false;

    }

    const getPostData = ({ uniqueNo, currentValues }) => {

        const repository = {
            number_alternative: uniqueNo,
            repo_date: currentValues.initialDate.format("YYYY-MM-DD"),
            remark: currentValues.remark
        }

        const props = {
            location_id: currentValues.locationId,
            uom_id: currentValues?.uomId,
            uom_lbl: currentValues?.uomName,
            packing_type: packingMethods.new.id, // use new 
            document_id: []
        }

        // console.log('props', props)

        // const items = [{
        //     id: 0,
        //     code: "**",
        //     name: "**",
        //     description: "**",
        //     qty: 1,
        //     uom_lbl: currentValues?.uomName,
        //     uom: currentValues?.uomId,
        //     price: "0"
        // }]

        const items = []

        return {
            repository,
            props,
            items
        }

    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
        enableReinitialize: true
    })

    const {
        handleSubmit,
        handleChange,
        values,
        errors,
        touched,
        setFieldValue
    } = formik;

    useEffect(() => {

        fetchUoms()

    }, [])

    const getBreadcumbActionMenus = () => {

        let props = []

        // if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
        //     props.push({
        //         displayText: "Load From ...",
        //         onClick: () => {

        //             // check the location is selected - valid
        //             if (validateLocationSelection() === false) {
        //                 promptMessage(false, `Please select any location`)
        //                 return false;
        //             }

        //             // setOpenSearchDocuments(true)
        //             setSearchDocumentConfig(prev => ({ ...prev, show: true }))

        //             return true;
        //         }
        //     })
        // }

        return props
    }

    const validateLocationSelection = () => {
        const selected = getLocationIds()
        return selected && selected.length === 1
    }

    const RenderFormInformation = () => {
        return (
            <StyledCard>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={4} textAlign={"left"}>

                        <CommonSectionHeader
                            title={`Basic Information`}
                            subTitle={`Provide package profile information`}
                        />

                        {/* {JSON.stringify(values)} */}

                    </Grid>
                    <Grid item xs={12} sm={12} md={8} sx={{}}>
                        <Grid container spacing={1}>

                            <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                                <TextField
                                    disabled
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"locationId"}
                                    label="Location"
                                    type="text"
                                    variant="outlined"
                                    value={values.locationDisplay}
                                    error={touched.locationId && Boolean(errors.locationId)}
                                    helperText={touched.locationId && errors.locationId}
                                    InputProps={{
                                        sx: {
                                            pr: 1
                                        },
                                        endAdornment: (
                                            <IconButton
                                                onClick={() => { setLocationIds([]) }}
                                                color="primary"
                                                size="small"
                                            >
                                                <CommonIcons name={icons.edit} />
                                            </IconButton>
                                        ),
                                    }}
                                />

                            </Grid>

                            <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                                <DatePickerComponent
                                    formik={{
                                        values,
                                        errors,
                                        touched,
                                        handleChange,
                                        setFieldValue
                                    }}
                                    config={{
                                        name: "initialDate",
                                        label: "Initial Date"
                                    }}
                                />

                            </Grid>

                            <Grid item xs={12} sm={12} md={6}>
                                <TextField
                                    // disabled={}
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={`qty`}
                                    label={`Qty`}
                                    type="text"
                                    variant="outlined"
                                    value={
                                        values?.qty?.value ? values.qty.value : ""
                                    }
                                    onChange={(event) => {
                                        setFieldValue(
                                            `qty`,
                                            {
                                                value: event.target.value,
                                                maxQty: parseFloat(values.qty.maxQty)
                                            }
                                        )
                                    }}
                                    onFocus={event => {
                                        event.target.select();
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                {
                                                    `/ ${values?.qty?.maxQty}`
                                                }
                                            </InputAdornment>
                                        )
                                    }}
                                    error={Boolean(errors?.qty?.value)}
                                    helperText={errors?.qty?.value}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={6}>
                                <FormControl
                                    margin="dense"
                                    fullWidth
                                    size="small"
                                    error={Boolean(errors?.uomId)}
                                >
                                    <InputLabel id="uomId">Package Uom</InputLabel>
                                    <Select
                                        labelId="uomId"
                                        label="uomId"
                                        name={`uomId`}
                                        // onChange={handleChange}
                                        onChange={(event) => {

                                            setFieldValue(`uomId`, event.target.value)

                                            const selected = dataUoms.filter(i => i.id === event.target.value)

                                            if (selected.length) {
                                                setFieldValue(`uomName`, selected[0].name)
                                            }

                                        }}
                                        value={values?.uomId ? values.uomId : ""}
                                        sx={{
                                            textAlign: 'left',
                                        }}
                                        MenuProps={{
                                            MenuListProps: {
                                                sx: {
                                                    py: 0
                                                },
                                            }
                                        }}
                                    >
                                        {
                                            dataUoms.map((i, index) => {
                                                return (
                                                    <MenuItem
                                                        key={index}
                                                        value={i.id}
                                                        sx={{
                                                            textTransform: 'capitalize',
                                                            px: 1.5,
                                                            fontSize: 14
                                                        }}
                                                        disableGutters
                                                        divider
                                                    >
                                                        {i.name}
                                                    </MenuItem>
                                                )
                                            })
                                        }
                                    </Select>
                                    <FormHelperText>
                                        {
                                            errors?.uomId
                                        }
                                    </FormHelperText>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={12} md={12}>
                                <TextField
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"remark"}
                                    label="Remark"
                                    type="text"
                                    variant="outlined"
                                    multiline
                                    rows={3}
                                    value={values.remark}
                                    onChange={handleChange}
                                    error={touched.remark && Boolean(errors.remark)}
                                    helperText={touched.remark && errors.remark}
                                />
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderFormDownload = () => {
        return (
            <StyledCard>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={`Ready Labels`}
                            subTitle={`Download the labels PDF`}
                        />

                    </Grid>
                    <Grid
                        item
                        xs={12} sm={12} md={12} sx={{ mt: 2 }}
                        textAlign={"center"}
                        display={"flex"}
                        flexDirection={"column"}
                        justifyContent={"center"}
                        alignItems={"center"}
                    >
                        <CommonIcons
                            name={icons.pdf}
                            sx={{
                                width: 100,
                                height: 100,
                                mb: 1
                            }}
                        />
                        <Button
                            variant="contained"
                            // size="small"
                            color={"primary"}
                            onClick={() => {
                                // handlePreviewPdf()

                                let params = new URLSearchParams();

                                let array = dataPackages.map(i => (
                                    encodeURIComponent(i?.number_alternative)
                                ))

                                params.set("packageNumbers", array);

                                console.log('array', array, dataPackages)

                                // redirect to view packing
                                window.open(`${getRoute(`repositories/package/view/?${params.toString()}`)}`)

                            }}
                        >
                            Print Labels ({dataPackages.length})
                        </Button>
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderForm = () => {
        return (
            <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={8} textAlign={"right"}>
                        {
                            RenderFormInformation()
                        }
                        <Button
                            type="submit"
                            // fullWidth
                            variant="contained"
                            sx={{
                                mt: 3,
                                mb: 2,
                                mx: 2
                            }}
                        // loading={isLoading}
                        >
                            Save Changes
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4}>

                        {
                            (dataPackages.length > 0) && RenderFormDownload()
                        }

                    </Grid>
                </Grid>
                <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                    <Grid item md={12} textAlign={"right"}>
                        <></>
                    </Grid>
                </Grid>
            </form>
        )
    }

    const RenderAll = () => {
        return validateLocationSelection() ?
            (
                RenderForm()
            )
            :
            (
                <LocationSelector
                    config={{
                        title: "Select Only (1) Location",
                        description: "You have to select anyone of the warehouse location to proceed"
                    }}
                    maxSelect={1}
                    handleOnNext={({ selected }) => {

                        setLocationIds([selected[0].id])
                        setFieldValue(`locationId`, selected[0].id)
                        setFieldValue(`locationDisplay`, selected[0].location_name)

                    }}
                />
            )
    }

    return (
        <Box>

            {
                getHtmlHead({ routeType, title: headTitles.newPackage })
            }

            <CommonBreadcumbs
                pageTitle="Generate Packages"
                actionMenus={
                    getBreadcumbActionMenus()
                }
                breadcrumbs={[
                    {
                        displayText: "Packages",
                        props: {
                            // underline: "hover",
                            href: getRoute("repositories/packages")
                        }
                    },
                    {
                        displayText: "Generate Packages",
                        props: {
                            // disabled: true,
                            color: 'secondary.main',
                            // href: getRoute("items/category")
                        }
                    },
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageNew.id }) ?
                    RenderAll()
                    :
                    <CommonRestricted />
            }

        </Box>
    )
}